import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y={4} width={32} height={24} rx={4} fill="white" />
    <rect
      x={0.5}
      y={4.5}
      width={31}
      height={23}
      rx={3.5}
      stroke="#161C24"
      strokeOpacity={0.1}
    />
    <path
      d="M22.0498 12.2459C21.4292 12.0215 20.7739 11.9084 20.114 11.9117C17.9832 11.9117 16.4773 12.9884 16.4682 14.5292C16.4507 15.6617 17.5357 16.3 18.3557 16.6817C19.1982 17.0725 19.4798 17.3159 19.4757 17.6625C19.4715 18.1967 18.8023 18.435 18.1865 18.435C17.3307 18.435 16.8665 18.3184 16.1507 18.0184L15.8848 17.8925L15.5815 19.6725C16.1023 19.885 17.0357 20.0717 17.999 20.0892C20.269 20.0892 21.749 19.0217 21.7657 17.3759C21.7832 16.4734 21.2023 15.7884 19.9648 15.2234C19.2182 14.8592 18.7507 14.6109 18.7507 14.2375C18.7507 13.9075 19.1498 13.5609 19.9832 13.5609C20.5362 13.547 21.086 13.6489 21.5973 13.86L21.8015 13.9509L22.1007 12.2367L22.0498 12.2459ZM27.589 12.0592H25.9223C25.4015 12.0592 25.0148 12.1984 24.7848 12.715L21.5815 19.9759H23.8473L24.304 18.7867L27.0682 18.7909C27.1373 19.0684 27.3323 19.975 27.3323 19.975H29.3332L27.589 12.0592ZM13.3998 11.9942H15.5573L14.2073 19.9142H12.0498L13.3998 11.99V11.9942ZM7.914 16.3559L8.13484 17.4584L10.2482 12.0592H12.5357L9.13234 19.9625H6.85484L4.98817 13.27C4.97387 13.2144 4.94839 13.1623 4.91329 13.1169C4.87819 13.0715 4.8342 13.0337 4.784 13.0059C4.11349 12.6571 3.40219 12.3931 2.6665 12.22L2.69234 12.0542H6.17317C6.64234 12.0717 7.024 12.22 7.154 12.7234L7.914 16.36V16.3559ZM24.919 17.1675L25.7832 14.95C25.7698 14.9709 25.9607 14.4942 26.069 14.1942L26.2165 14.875L26.7165 17.1625H24.919V17.1675Z"
      fill="#00579F"
    />
    <path
      d="M7.914 16.3559C7.61554 14.9319 4.8342 13.0337 4.784 13.0059C4.11349 12.6571 3.40219 12.3932 2.6665 12.22L2.69234 12.0542H6.17317C6.64234 12.0717 7.024 12.22 7.154 12.7234L7.914 16.36V16.3559Z"
      fill="#FAA61A"
    />
  </svg>
);
export default SVGComponent;
